import moment from 'moment';

// 时间格式
export const timeFormatType = {
    date_no_year: "MM-DD",
    date: "YYYY-MM-DD",
    month: "YYYY-MM",
    time: "YYYY-MM-DD HH:mm:ss",
    ch_date_no_year: "MM月DD日",
    ch_date: "YYYY年MM月DD日",
    date_no_split: "YYYYMMDD",
    time_xg: "YYYY/MM/DD HH:mm",
    month_no_split: "YYYYMM",
    date_xg: "YYYY/MM/DD",
    date_point: "YYYY.MM.DD",
}

// 获取指定格式的时间
export function renderDate(time, type) {
    return time ? moment(time).format(type) : "--"
}

// 获取指定格式的时间区间
export function renderDateRange(times, type) {
    return `${times[0] ? moment(times[0]).format(type) : "--"} - ${times[1] ? moment(times[1]).format(type) : "--"}`
}

// 获取时间区间，不直接用object是因为这里定义object之后，获取key值就不会获取到实时的时间区间
export const dateRange = {
    "10MIN": [
        moment()
            .subtract(10, "minutes"),
        moment()
    ],
    "2H": [
        moment()
            .subtract(2, "hours"),
        moment()
    ],
    "1天": [moment().startOf("day"), moment().endOf("day")],
    "3天": [
        moment()
            .subtract(2, "day")
            .startOf("day"),
        moment().endOf("day")
    ],
    "7天": [
        moment()
            .subtract(6, "day")
            .startOf("day"),
        moment().endOf("day")
    ],
    "30天": [
        moment()
            .subtract(29, "day")
            .startOf("day"),
        moment().endOf("day")
    ],
    "90天": [
        moment()
            .subtract(89, "day")
            .startOf("day"),
        moment().endOf("day")
    ],
    昨天: [
        moment()
            .subtract(1, "day")
            .startOf("day"),
        moment()
            .subtract(1, "day")
            .endOf("day")
    ],
    当日: [moment().startOf("day"), moment().endOf("day")],
    上周: [
        moment()
            .subtract(1, "week")
            .startOf("week")
            .startOf("day"),
        moment()
            .subtract(1, "week")
            .endOf("week")
            .endOf("day")
    ],
    本周: [
        moment()
            .startOf("week")
            .startOf("day"),
        moment().endOf("day")
    ],
    一周: [
        moment()
            .subtract(1, "week")
            .startOf("day"),
        moment().endOf("day")
    ],
    上月: [
        moment()
            .subtract(1, "month")
            .startOf("month")
            .startOf("day"),
        moment()
            .subtract(1, "month")
            .endOf("month")
            .endOf("day")
    ],
    上上月: [
        moment()
            .subtract(2, "month")
            .startOf("month")
            .startOf("day"),
        moment()
            .subtract(2, "month")
            .endOf("month")
            .endOf("day")
    ],
    本月: [
        moment()
            .startOf("month")
            .startOf("day"),
        moment().endOf("day")
    ],
    一月: [
        moment()
            .subtract(1, "month")
            .startOf("day"),
        moment().endOf("day")
    ],
    三月: [
        moment()
            .subtract(3, "month")
            .startOf("day"),
        moment().endOf("day")
    ],
    本季: [
        moment()
            .startOf("quarter")
            .startOf("day"),
        moment().endOf("day")
    ],
    本年: [
        moment()
            .startOf("year")
            .startOf("day"),
        moment().endOf("day")
    ],
    一年: [
        moment()
            .subtract(12, "month")
            .startOf("day"),
        moment().endOf("day")
    ],
    前3月: [
        moment()
            .subtract(3, "month")
            .startOf("month")
            .startOf("day"),
        moment()
            .subtract(1, "month")
            .endOf("month")
            .endOf("day")
    ],
    前6月: [
        moment()
            .subtract(6, "month")
            .startOf("month")
            .startOf("day"),
        moment()
            .subtract(1, "month")
            .endOf("month")
            .endOf("day")
    ],
}

export const getDateRange = (dateKey) => {
    return dateRange[dateKey]
}

/**
 * 获取相对于当前时间的表现形式
 */
export function timeFromNow(time) {
    const format = "YYYY/MM/DD HH:mm";
    const formatDate = "YYYY/MM/DD";
    const formatTime = "HH:mm:ss";
    let timeStr = moment(time).format(format);
    if (moment(time).format(formatDate) === moment().format(formatDate)) {
        let fromNowStr = moment(time).fromNow(true);
        if (fromNowStr.indexOf("小时") > 0 && parseInt(fromNowStr) > 5) {
            timeStr = "今天 " + moment(time).format(formatTime);
        } else {
            if (fromNowStr.indexOf('seconds') > -1) {
                fromNowStr = '几秒';
            } else if (fromNowStr.indexOf('minutes') > -1) {
                fromNowStr = fromNowStr.replace('minutes', '分钟');
            } else if (fromNowStr.indexOf('hours') > -1) {
                fromNowStr = fromNowStr.replace('hours', '小时');
            }
            timeStr = fromNowStr + "前"
        }
    }
    return timeStr
}


// 时间段处理，开始时间取0点，结束时间取23:59:59
export const getRangeDatesOfDate = (dates) => {
    if (dates && dates.length === 2) {
        return [moment(dates[0]).startOf('day'), moment(dates[1]).endOf('day')]
    }
    return dates
}